'use client'

import { useEffect, useState } from 'react'

/** On the check-email screen this long without signing in, offer Google sign-in. */
export const GOOGLE_NUDGE_IDLE_MS = 30_000
/** After a wrong code or a resend, offer it this much later (lets the error be read first). */
export const GOOGLE_NUDGE_TROUBLE_DELAY_MS = 1_500

/**
 * Whether to show "Sign in with Google" on the check-email screen. `active`
 * is true only while that screen is up for a Google-hosted mailbox – for any
 * other mailbox Google sign-in would create a second account. `troubles`
 * counts wrong codes plus resends.
 */
export function useGoogleNudge(active: boolean, troubles: number): boolean {
  const [shown, setShown] = useState(false)

  useEffect(() => {
    if (!active) return
    const timer = setTimeout(() => setShown(true), GOOGLE_NUDGE_IDLE_MS)
    // Leaving the screen (back, another address) starts the next one clean.
    return () => { clearTimeout(timer); setShown(false) }
  }, [active])

  useEffect(() => {
    if (!active || troubles === 0) return
    const timer = setTimeout(() => setShown(true), GOOGLE_NUDGE_TROUBLE_DELAY_MS)
    return () => clearTimeout(timer)
  }, [active, troubles])

  return active && shown
}
